import { useState } from "react";
import { Button, EmptyState, InfoBox, Loading, Modal, Tabs } from "../ui";
import { canManageScholarships } from "../scholarships/access";

/**
 * A call's whole set-up in one dialog, one tab per part: a scholarship or a loan call. Each panel
 * gets `panelProps`; those who cannot manage calls see `readOnlyNote` above the tabs. A new
 * `panelKey` remounts the panel, e.g. once its drafts were saved from outside it.
 */
export default function SetupDialog({ open, onClose, title, tag, tabs, panels, panelProps, initialTab, isPending, isError, onRefresh, readOnlyNote, actions, panelKey }) {
  const [tab, setTab] = useState(initialTab ?? tabs[0].value);
  const Panel = panels[tab];

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="full"
      title={
        <span className="flex flex-wrap items-center gap-3">
          {title ?? "Set-up"}
          {tag}
        </span>
      }
      footer={
        <>
          {actions}
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
        </>
      }
    >
      {isPending ? (
        <Loading label="Loading…" />
      ) : isError ? (
        <EmptyState title="Could not load it" description="It may have been removed, or you may not have access." onRefresh={onRefresh} />
      ) : (
        <div className="flex flex-col gap-6">
          {!canManageScholarships() && <InfoBox>{readOnlyNote}</InfoBox>}
          <Tabs tabs={tabs} value={tab} onChange={setTab} className="max-w-full overflow-x-auto" />
          {Panel && <Panel key={panelKey} {...panelProps} />}
        </div>
      )}
    </Modal>
  );
}
